module.exports = __webpack_public_path__ + "static/media/wishList.0818c089.svg";